//import React, { useState, useEffect } from 'react';


import ImmobilizeVehicleChime from "@public/sound/engineStarted.wav"
import ToolOn from "@public/sound/toolOn.mp3"
import ToolOff from "@public/sound/toolOff.mp3"
import ToolLocking from "@public/sound/toolLocking.wav"
import WrongMode from "@public/sound/wrongMode.wav"


const immobilizeVehicleChime = new Audio(ImmobilizeVehicleChime);
const toolOn = new Audio(ToolOn);
const toolOff = new Audio(ToolOff);
const wrongMode = new Audio(WrongMode)

const soundAlert = {
  "engineStart": immobilizeVehicleChime,
  "toolOn": toolOn,
  "toolOff": toolOff,
  "wrongMode": wrongMode
};

const hasPlayedSoundAlert = {};

export default function playSoundAlert(alerts) {
  for (let key in soundAlert) {
    if (!alerts.some(alert => alert.id === key)) {
      hasPlayedSoundAlert[key] = false;
    }
    for (let alert of alerts) {
      if (alert['id'] === key && hasPlayedSoundAlert[key] !== true) {
        soundAlert[key].play();
        console.log(`playing ${key}`);
        hasPlayedSoundAlert[key] = true;
      }
    }
  }
}
